module.exports = __webpack_public_path__ + "img/invest_list2.84ffae39.png";